import { FC, Fragment, memo } from "react";
import styles from "./payment-methods.module.css";

type PaymentsMethodsProps = {
  paymentMethods?: {name: string;logo?: string;option?: boolean;}[];
  lightMode?: boolean;
};

const PaymentsMethods: FC<PaymentsMethodsProps> = memo(
  ({ paymentMethods, lightMode }) =>
  <div
    className={`${styles.paymentMethods} ${lightMode && styles.lightTheme}`}>

      <h4 className={styles.title}>Aceptamos</h4>
      <div className={styles.list}>
        {paymentMethods?.map((paymentMethod, index) =>
      <Fragment key={`paymenth-method-${index}`}>
            <img
          src={`${paymentMethod.logo}`}
          className={`${paymentMethod.option ? styles.option : ""}`}
          alt={paymentMethod.name} />

          </Fragment>
      )}
      </div>
    </div>

);

export default PaymentsMethods;